import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from 'react';
import { c } from 'ttag';
import Button from '@/Components/Button/Button';
import ModalDialogButtons from '../Modal/ModalDialogButtons';
import Modal from '../Modal/Modal';
const jtString = (value) => (Array.isArray(value) ? value.join('') : String(value));
const PermissionsModal = ({ callback, component, dismiss, permissionsString }) => {
    const accept = useCallback(() => {
        callback(true);
        dismiss();
    }, [callback, dismiss]);
    const deny = useCallback(() => {
        callback(false);
        dismiss();
    }, [callback, dismiss]);
    return (_jsx(Modal, { title: c('B2.NavSharedUI.Title').t `Activate Plugin`, close: deny, actions: [
            { label: c('B2.NavSharedUI.Action').t `Cancel`, onClick: deny, type: 'cancel', mobileSlot: 'left' },
            {
                label: c('B2.NavSharedUI.Action').t `Continue`,
                onClick: accept,
                type: 'primary',
                mobileSlot: 'right',
            },
        ], customFooter: _jsx(ModalDialogButtons, { className: "hidden md:flex", children: _jsx(Button, { primary: true, fullWidth: true, onClick: accept, className: "block", children: c('B2.NavSharedUI.Action').t `Continue` }) }), children: _jsxs("div", { className: "px-4 py-4", children: [_jsx("div", { className: "text-base", children: _jsx("strong", { children: jtString(c('B2.NavSharedUI.Info')
                            .jt `${component.displayName} would like to interact with your ${permissionsString}`) }) }), _jsx("div", { className: "sk-panel-row [word-break:break-word]", children: _jsx("p", { className: "sk-p", children: c('B2.NavSharedUI.Info')
                            .t `Plugins use an offline messaging system to communicate and can only access the current note.` }) })] }) }));
};
export default PermissionsModal;
